import { call } from "redux-saga/effects";
import { uploadBuffer } from "../fileUploadSaga";
import { resolvePublicMediaUrl } from "../../../utils/s3MediaUrl";

/**
 * Workflow builder media: S3 presign + PUT only. Stores the public HTTPS URL on the node.
 *
 * Do NOT use for campaigns or template headers — those need Meta media IDs via
 * `uploadCampaignTemplateMedia` in `store/sagas/whatsapp/campaignMediaHelper.js`.
 *
 * @returns {{ ok: true, url: string, filename: string }} | {{ ok: false, errMsg: string }}
 */
export function* uploadWorkflowMediaToS3({ file, companyId }) {
  if (!file) {
    return { ok: false, errMsg: "Missing file for upload" };
  }

  const mediaUploadResult = yield call(uploadBuffer, {
    fileName: file.name,
    contentType: file.type || "application/octet-stream",
    data: file,
    customerId: companyId,
    operation: "whatsapp-feature"
  });

  const url = resolvePublicMediaUrl({
    uploadURL: mediaUploadResult?.uploadURL,
    s3Key: mediaUploadResult?.fileURL,
  });

  if (!url || url.startsWith("s3://")) {
    return { ok: false, errMsg: "Failed to upload media" };
  }

  return {
    ok: true,
    url,
    filename: file.name
  };
}
